const e=async(e,t)=>{let{data:n}=await e.get(`/orgs/${t}`);return n};export{e as getOrg};
//# sourceMappingURL=get-org.mjs.map